import { HttpClient } from 'aurelia-fetch-client';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import 'whatwg-fetch';
import config from '../config/config';
import { State } from './global-state';
import { I18N } from 'aurelia-i18n';
import { ApiResponse } from "../models/api-response";

@autoinject
export class RestServiceClient {
    base: string;
    queryParameters: any;

    constructor(
        private globalState: State,
        private http: HttpClient,
        private router: Router,
        private i18n: I18N
    ) {
        this.base = config.serviceUrl;
        this.queryParameters = {};
		location.search.substr(1).split("&").forEach(item => { 
            const index = decodeURI(item.split("=")[0].toLowerCase());
            const value = decodeURI(item.split("=")[1]).replace("undefined", ""); 
            this.queryParameters[index] = value; 
        });
    }

    get(url: string): Promise<ApiResponse> {
        let init = {
            method: 'get',
            headers: new Headers({
                'Content-Type': 'application/json',
                'PayrazrSessionId': this.globalState.business ? this.globalState.business.sessionId : null
            })
        }

        return new Promise<ApiResponse>((resolve) => {
            return this.http
                .fetch(`${this.base}${url}`, init)
                .then(response => {
                    response.json()
                        .then((responseJson: ApiResponse) => {
                            resolve(this.createApiResponseFromHttpResponse(responseJson));
                        })
                        .catch(error => {
                            resolve(new ApiResponse({
                                isSuccessful: false,
                                errors: ['API Get Failed.']
                            }));
                        });
                })
                .catch(error => {
                    resolve(new ApiResponse({
                        isSuccessful: false,
                        errors: ['API Get Failed.']
                    }));
                });
        });
    }

    post(url: string, content: any): Promise<ApiResponse> {
        let request = JSON.stringify(content);

        let init = {
            method: 'post',
            headers: new Headers({
                'Content-Type': 'application/json',
                'PayrazrSessionId': this.globalState.business ? this.globalState.business.sessionId : null
            }),
            body: request
        };

        return new Promise<ApiResponse>((resolve) => {
            return this.http
                .fetch(`${this.base}${url}`, init)
                .then(response => {
                    response.json()
                        .then((responseJson: ApiResponse) => {
                            resolve(this.createApiResponseFromHttpResponse(responseJson));
                        })
                        .catch(error => {
                            resolve(new ApiResponse({
                                isSuccessful: false,
                                errors: ['API Post Failed.']
                            }));
                        });
                })
                .catch(error => {
                    resolve(new ApiResponse({
                        isSuccessful: false,
                        errors: ['API Post Failed.']
                    }));
                });
        });
    }

    delete(url: string, content: any): Promise<ApiResponse> {
        let request = JSON.stringify(content);

        let init = {
            method: 'delete',
            headers: new Headers({
                'Content-Type': 'application/json',
                'PayrazrSessionId': this.globalState.business ? this.globalState.business.sessionId : null
            }),
            body: request
        };

        return new Promise<ApiResponse>((resolve) => {
            return this.http
                .fetch(`${this.base}${url}`, init)
                .then(response => {
                    response.json()
                        .then((responseJson: ApiResponse) => {
                            resolve(this.createApiResponseFromHttpResponse(responseJson));
                        })
                        .catch(error => {
                            resolve(new ApiResponse({
                                isSuccessful: false,
                                errors: ['API Delete Failed.']
                            }));
                        });
                })
                .catch(error => {
                    resolve(new ApiResponse({
                        isSuccessful: false,
                        errors: ['API Delete Failed.']
                    }));
                });
        });
    }

    put(url: string, content: any): Promise<ApiResponse> {
        let request = JSON.stringify(content);

        let init = {
            method: 'put',
            headers: new Headers({
                'Content-Type': 'application/json',
                'PayrazrSessionId': this.globalState.business ? this.globalState.business.sessionId : null
            }),
            body: request
        };

        return new Promise<ApiResponse>((resolve) => {
            this.http
                .fetch(`${this.base}${url}`, init)
                .then(response => {
                    response.json()
                        .then((responseJson: ApiResponse) => {
                            resolve(this.createApiResponseFromHttpResponse(responseJson));
                        })
                        .catch(error => {
                            resolve(new ApiResponse({
                                isSuccessful: false,
                                errors: ['API Put Failed.']
                            }));
                        });
                })
                .catch(error => {
                    resolve(new ApiResponse({
                        isSuccessful: false,
                        errors: ['API Put Failed.']
                    }));
                });
        });
    }

    // explicitly map the http json response into an api response in order to overcome 
    // serialization issues that come with implicit serialization (e.g. methods undefined)
    createApiResponseFromHttpResponse(responseJson: ApiResponse): ApiResponse {
        return new ApiResponse({
            isSuccessful: responseJson.isSuccessful,
            resultCode: responseJson.resultCode,
            value: responseJson.value,
            logMessages: responseJson.logMessages,
            errors: responseJson.errors
        });
    }
}

